import * as React from 'react';
import CloseFilterButton from './CloseFilterButton';

function FilterLabel({ filterName, filterOption, onRemove }) {
    const handleRemove = () => {
        onRemove(filterName);
    };

    return (
        <div className='filter_label'>
            <CloseFilterButton onClick={handleRemove} />
            <div className='counter__wrapper'>
                {filterOption.map((option => (
                    <p>{option}</p>
                )))}
            </div>
        </div>
    );
}

export default FilterLabel;
